import { handleFormSubmit, useRequest } from '@polvo-labs/react-auth'
import React from 'react'
import { toast } from 'react-toastify'
import Form from '../../components/Form'
import fields, { ForgotFormData } from './fields'

interface Props {
  onSubmit: () => void
}

const ForgotForm: React.FC<Props> = ({ onSubmit }) => {
  const { request } = useRequest()

  return (
    <Form<ForgotFormData>
      buttonLabel="RECUPERAR SENHA"
      fields={fields}
      onSubmit={data => handleFormSubmit({
        request: request({
          method: 'POST',
          url: `${process.env.REACT_APP_API_URL}/password/create`,
          data,
        }),
        onFailure: (e: any) => toast.error('Ocorreu um erro na sua solicitação: ' + e.response.data.message),
        onSuccess: () => onSubmit(),
        onValidationErrors: (e: any) => () => toast.error('Ocorreu um erro na sua solicitação: ' + e.response.data.message),
      })}
    />
  )
}

export default ForgotForm
